<template>
  <div class="main" @click.self="$emit('close')">
    <div class="box-modal">
      <span class="title">سفارش شما</span>

      <div class=""><p>آیا از سفارش خود اطمینان دارید؟</p></div>

      <div class="order">


        <div class="data-list">
          <span>مقدار</span>
          <span>{{amount}}</span>
        </div>
        <div class="data-list">

          <span>کارمزد</span>
          <span>%{{state.userInfo.fee}}</span>
        </div>
        <div class="data-list">
          <span>دریافتی</span>
          <span>{{totalPrice}}</span>
        </div>

 <div class="data-list" v-if="date !==''">
          <span>تاریخ انقضا</span>
          <span>{{$G2J(date)}}</span>
        </div>

      </div>


      <button @click.prevent='accept' class="blue-btn">تایید</button>
    </div>
  </div>
</template>

<script>

export default {
  name: "sellModal",
    props:['unitPrice' , 'totalPrice' , 'amount' , 'date' , 'type','limit','stopPrice'],
  // props: {
  //   data: {
  //     type: Object,
  //   },
  // },
  // required: true
  // components: {CustomInput}
  methods: {
          async accept() {
           
            let orderDetail;
            let marketType = this.$route.params.tradeFrom + '_' + this.$route.params.tradeTo

            if (this.limit =='limit') {
                orderDetail = {
                    marketType: marketType,
                    amount: this.$S2N(this.amount),
                    orderType: `LIMITED_SELL`,
                    expiresAt: this.date || null,
                    unitPrice: this.$S2N(this.unitPrice),
                    wholePrice: this.$S2N(this.totalPrice),
                }
            }

            else if (this.limit ==='Stop-Limit'){
              console.log('stop-limit')
              orderDetail = {
                marketType :marketType,
                amount: this.$S2N(this.amount),
                orderType: `STOP_LIMIT_SELL`,
                expiresAt: this.date || null,
                unitPrice: this.$S2N(this.unitPrice),
                wholePrice: this.$S2N(this.totalPrice),
                stopPrice : this.$S2N(this.stopPrice)
              }
            }

            else if (this.limit ==='OCO'){

              orderDetail = {
                marketType :marketType,
                amount: this.$S2N(this.amount),
                orderType: `OCO_SELL`,
                expiresAt: this.date || null,
                unitPrice: this.$S2N(this.unitPrice),
                wholePrice: this.$S2N(this.totalPrice),
                stopPrice : this.$S2N(this.stopPrice)
              }
            }









            else {
                orderDetail = {
                    marketType: marketType,
                    amount: this.$S2N(this.amount),
                    orderType: `MARKET_SELL`,
                }
            }
            try {
                 this.state.loading = true;
                await this.$axios.post(`/orders/sell`, orderDetail, {
                    params: {
                        force: true
                    }
                })
                this.loading = false
                this.$emit('close')
                 this.state.loading = false;
                this.$error('', 'سفارش با موفقیت ثبت شد', 'success')
                ++this.state.orderChange
                console.log(this.state.orderChange)
            } 
            catch (error) {
                this.loading = false
                this.$emit('close')
                if (error.response.data.message) {
                    //  === "the amount of order is bigger than market liquidity"
                    // await this.$error('', 'حجم درخواستی بیش از مقدار بازار است.')
                    this.$error('', error.response.data.message)
                }
            }
             this.state.loading = false;
        },
  },
}
</script>

<style lang="scss" scoped>
.order{
  display: flex;
  flex-direction: column;
  gap: 4px;
  .data-list{
    display: flex;
    justify-content: space-between;
  }
}
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0, 0.7);
  z-index: 10;

  .box-modal {
    background-color: rgba(11, 20, 38, 1);
    display: flex;
    min-width: 250px;
    flex-direction: column;
    color: #FFFFFF;
    border-radius: 16px;
    padding: 16px;
    gap: 20px;

    .title {
      font-size: clamp(14px, 2vw, 16px);
      color: #FFFFFF;
      font-weight: bold;
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 28px;
    }

  }
}
</style>